import { motion, useScroll, useTransform } from "framer-motion";
import { MapPin, User, Sparkles } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1759502141256-45d54807853b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBnYXJkZW4lMjBmZW5jZXxlbnwwfHx8fDE3ODc5NDUwMDB8MA&ixlib=rb-4.1.0&q=85";

const PILLS = [
  { icon: MapPin, label: "Regional aus Minden" },
  { icon: User, label: "Persönliche Betreuung" },
  { icon: Sparkles, label: "Saubere Ausführung" },
];

export default function Hero() {
  const { scrollY } = useScroll();
  const imageY = useTransform(scrollY, [0, 800], [0, 240]);
  const imageOpacity = useTransform(scrollY, [0, 700], [1, 0]);
  const contentY = useTransform(scrollY, [0, 800], [0, -120]);
  const contentOpacity = useTransform(scrollY, [0, 550], [1, 0]);

  return (
    <section id="start" className="relative min-h-screen flex items-end overflow-hidden" data-testid="hero-section">
      <motion.div style={{ y: imageY, opacity: imageOpacity }} className="absolute inset-0 -bottom-64">
        <img
          src={HERO_IMG}
          alt="Moderner Zaun mit sattgrüner Hecke"
          className="w-full h-full object-cover"
        />
      </motion.div>
      <motion.div style={{ opacity: imageOpacity }} className="absolute inset-0 bg-gradient-to-t from-[#141614]/90 via-[#141614]/40 to-[#141614]/20" />
      <div className="absolute bottom-0 inset-x-0 h-48 bg-gradient-to-b from-transparent to-[#F9F8F6] z-[5] pointer-events-none" data-testid="hero-blend" />
      <motion.div
        style={{ y: contentY, opacity: contentOpacity }}
        className="relative z-10 px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto w-full pb-20 sm:pb-28 pt-40"
      >
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <div className="mb-8 inline-flex bg-white rounded-2xl px-6 py-4 shadow-2xl shadow-black/30" data-testid="hero-logo-card">
            <img src="/logo.jpg" alt="LLP Zaun&Garten Logo" className="h-16 sm:h-20 w-auto" />
          </div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#C89D66] mb-5" data-testid="hero-overline">
            Garten- & Landschaftsbau · Minden
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.1] text-white" data-testid="hero-headline">
            Meisterhafter Zaunbau & Gartenarbeiten in Minden
          </h1>
          <p className="mt-6 text-base sm:text-lg text-zinc-300 leading-relaxed max-w-xl" data-testid="hero-subline">
            Zäune, Gartenarbeiten, Erdarbeiten & Drainage – zuverlässig geplant und sauber ausgeführt.
            Alles aus einer Hand, direkt von Inhaber Anatoli Zygankow.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#termin"
              data-testid="hero-cta-booking"
              className="bg-[#C89D66] hover:bg-[#b8894f] text-[#1A1C19] font-bold px-8 py-4 rounded-full transition-colors text-sm sm:text-base"
            >
              Jetzt Termin buchen
            </a>
            <a
              href="#leistungen"
              data-testid="hero-cta-services"
              className="border border-white/40 hover:border-white text-white font-semibold px-8 py-4 rounded-full transition-colors text-sm sm:text-base"
            >
              Unsere Leistungen
            </a>
          </div>
          <div className="mt-12 flex flex-wrap gap-3">
            {PILLS.map(({ icon: Icon, label }) => (
              <span
                key={label}
                className="flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 text-white text-xs sm:text-sm font-medium px-4 py-2 rounded-full"
              >
                <Icon className="w-4 h-4 text-[#C89D66]" />
                {label}
              </span>
            ))}
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}
